var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5791,
    cy: 8.1582,
    r: 7.65217,
    stroke: "#A2A2A6",
    strokeWidth: 0.695652
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCircleIcon);
export default __webpack_public_path__ + "static/media/emptyCircleIcon.b8c3c5b2bd509cb2a7cb19880c43d717.svg";
export { ForwardRef as ReactComponent };